module.exports = __webpack_public_path__ + "static/favicon-8d30cf4653d6e990234e90ce81d7483c.png";